// assets/commaxx-mobile-icons-slider.js

document.addEventListener('DOMContentLoaded', function () {
  const MOBILE_MAX_WIDTH = 767;

  // Alle relevante secties zoeken op basis van class i.p.v. id
const sections = document.querySelectorAll('.icons-with-text.section');

  if (!sections.length) return;

  sections.forEach(function (section) {
    initMobileIconsSlider(section);
  });

  function initMobileIconsSlider(section) {
    const slider = section.querySelector('.slider');
    if (!slider) return;

    const items = Array.from(slider.querySelectorAll('.slider__item'));
    if (items.length <= 1) return; // niets te sliden

    // Delay ophalen (optioneel data-slide-delay op de container zetten)
    const delayAttr = section.getAttribute('data-slide-delay');
    const SLIDE_DELAY = parseInt(delayAttr, 10) || 5000;

    let currentIndex = 0;
    let intervalId = null;

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX_WIDTH;
    }

    function goToSlide(index) {
      if (!items[index]) return;

      currentIndex = index;
      const target = items[currentIndex];
      const left = target.offsetLeft;

      slider.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % items.length;
      goToSlide(nextIndex);
    }

    function startAutoSlide() {
      if (!isMobile()) return;
      if (intervalId !== null) return;

      intervalId = window.setInterval(function () {
        if (!isMobile()) return;
        nextSlide();
      }, SLIDE_DELAY);
    }

    function stopAutoSlide() {
      if (intervalId !== null) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Start op load als het mobiel is
    if (isMobile()) {
      goToSlide(0);
      startAutoSlide();
    }

    // Op resize: aan op mobiel, uit op desktop
    window.addEventListener('resize', function () {
      if (isMobile()) {
        goToSlide(currentIndex);
        startAutoSlide();
      } else {
        stopAutoSlide();
        slider.scrollTo({ left: 0 });
        currentIndex = 0;
      }
    });

    // Optioneel: pauze bij hover
    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function () {
      if (isMobile()) startAutoSlide();
    });
  }
});
